import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { ResponseDTO } from './responseDTO.types';
import { useRouteParams } from '../hooks/useRouteParams';
import { MESSAGES } from '../../../CommonConstants';
import { selectCurrentClient } from '../../../CommonSelectors/CommonAreaSelector';

const URLS_MAP = {
  ClientSettings: 'consumer/ClientSettings/CurrentYearAssumptions',
  MySettings: 'adviser/settings/CurrentYearMyAssumptions',
  FirmSettings: 'adviser/settings/CurrentYearFirmAssumptions',
};

const fetchCurrentYearAssumptions = (url: string) => async (
  clientId?: number,
): Promise<ResponseDTO> => {
  return authFetch(urlWithParams(url, { ...(clientId ? { clientId } : {}) }));
};

export const useCurrentYearAssumptionsQuery = () => {
  const currentClient = useSelector(selectCurrentClient);
  const { page } = useRouteParams();

  return useQuery(
    queryKeys.currentYearAssumptions(!!currentClient?.Id, page),

    () => {
      if (currentClient?.Id) {
        return fetchCurrentYearAssumptions(URLS_MAP.ClientSettings)(currentClient.Id);
      }

      if (page) {
        return fetchCurrentYearAssumptions(URLS_MAP[page])();
      }

      throw new Error(MESSAGES.GENERIC_ERROR);
    },

    { cacheTime: 0 },
  );
};
